import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.getHealthCheckSetting.loading;
export const selectErrorMessage = (state: RootState) =>
  state.getHealthCheckSetting.error;
export const getHealthCheckSettingResponse = (state: RootState) =>
  state.getHealthCheckSetting.getHealthCheckSettingResponse;
